import { render } from "./ImpressumContent.vue?vue&type=template&id=b1817c88&scoped=true"
import script from "./ImpressumContent.vue?vue&type=script&lang=js"
export * from "./ImpressumContent.vue?vue&type=script&lang=js"

import "./ImpressumContent.vue?vue&type=style&index=0&id=b1817c88&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1817c88"]])

export default __exports__